import { Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  title: string
}

export const TitleAndContent = ({ children, title }: Props) => {
  return (
    <Box
      component="fieldset"
      sx={{
        border: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
      aria-label={title}
    >
      <Typography component="legend" variant="subtitle1">
        {title}
      </Typography>
      {children}
    </Box>
  )
}
